import { memo, useCallback, useContext, useEffect, useMemo, useState } from "react";
import {
    Select,
    LinearProgress,
    Paper,
    IconButton,
    TextField,
    InputAdornment,
    MenuItem,
    ListItemText,
    Checkbox
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from "@mui/icons-material/Search";
import { debouncingFn } from "../../../utils/Reusables";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import { ReactComponent as DropDownCancelIcon } from "../../../assets/icons/icon_close.svg"
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
    header: {
        position: "sticky",
        top: 0,
        zIndex: 2,
        marginTop: '-8px',
    },
    search: {
        marginBottom: "1px",
    },
    card: {
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        display: 'flex',
        backgroundColor: "#fff4f0",
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
});

const AsyncSelectInput = ({ fetchFn, handleChange, defaultValue }) => {
    const classes = useStyles()
    const [list, setList] = useState([])
    const [loader, setLoader] = useState(false)
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchKey, setSearchKey] = useState('')
    const [prevSearchKey,setPrevSearchKey] = useState('')

    const handleMenuOpen = useCallback(() => {
        setMenuOpen(!menuOpen)
        setPrevSearchKey(searchKey)
    })

    const handleSearchKey = useCallback((event) =>{
        setPrevSearchKey(searchKey)
        setSearchKey(event.target.value)
    })

    useEffect(() => {
        setLoader(false)
        //console.log(list)
    },[list])

    useEffect(debouncingFn(((list.length == 0 || searchKey != prevSearchKey) && menuOpen) ? () => fetchFn(searchKey,setLoader,setList): () => {}),[menuOpen,searchKey])

    return <Select
                multiple
                value={defaultValue}
                renderValue={(selected) => selected.join(", ")}
                size={'auto'}
                open={menuOpen}
                onChange={handleChange}
                onClose={handleMenuOpen}
                onOpen={handleMenuOpen}
                className="report_form_ui_input_select"
                // IconComponent={
                //     defaultValue
                //         ? () => (
                //             <IconButton
                //             size="small"
                //             onClick={handleMenuOpen}
                //             >
                //                 <CloseIcon />
                //             </IconButton>
                //         )
                //         : <DropDownIcon />
                // }
                IconComponent={DropDownIcon}
                MenuProps={{
                    autoFocus:false,
                    classes: {
                        root: `form-select-menu re-form-select-menulist`
                    }
                }}
            >
                <div className={classes.header}>
                    <Paper className={classes.card}>
                        <IconButton className="form-icon-btn" onClick={handleMenuOpen} color="primary"> <CancelIcon /></IconButton>
                    </Paper>
                    <Paper elevation={3}>
                    <TextField
                        size="small"
                        value={searchKey}
                        className="cm_rprt_setting_content  report_input_field_list"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={handleSearchKey}
                        onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                                e.stopPropagation();
                            }
                        }}
                    />
                    </Paper>                    
                </div>                
                {loader ? <LinearProgress /> :''}
                {
                    list.map(obj => (
                        <MenuItem key={obj.value} title={obj.label ?? 'NA'} className={classes.menuDropdownItem + " menu-item flex"} value={obj.value}>
                            <Checkbox className="form_checkbox" checked={defaultValue.indexOf(obj.value) > -1} />
                            <ListItemText primary={obj.label ?? 'NA'} />
                        </MenuItem>
                    ))
                }                
            </Select>
        
}

export default memo(AsyncSelectInput)